









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import AdminContentCampaignFinancialTableRow
  from '@/modules/content-campaign/components/admin/table/AdminContentCampaignFinancialTableRow.vue'
import { isDef } from '@/modules/shared/helpers/utils/utils'
import { Prop } from 'vue-property-decorator'
import {
  adminContentCampaignFinancialTableColumns
} from '@/modules/content-campaign/models/columns/admin-content-campaign-financial-table.column'
import { ContentCampaignResourceModelInAdmin } from '@/modules/content-campaign/models/content-campaign-resource.model'

@Component({
  components: {
    TesTable
  }
})
export default class AdminContentCampaignFinancialTable extends Vue {
  @Prop({ required: true }) contentCampaignResource!: ContentCampaignResourceModelInAdmin

  rowComponent = AdminContentCampaignFinancialTableRow

  get columns() {
    const cols = adminContentCampaignFinancialTableColumns()
    if (isDef(this.contentCampaignResource.profit)) {
      return cols
    }
    return cols.filter(col => col.field !== 'profit')
  }
}
